import { render, staticRenderFns } from "./OrderDetailsLink.vue?vue&type=template&id=d1d5682a"
import script from "./OrderDetailsLink.vue?vue&type=script&lang=js"
export * from "./OrderDetailsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports